require("../style/main");
import "./prototypes";
import "./pubSub";
import "./root";
